import marketI from "../images/market.svg"
import cuisineI from "../images/cuisine.svg"
import groceryI from "../images/grocery.svg"
import barsI from "../images/bars.svg"
import globeI from "../images/globe-green-dark.svg"
import vegesI from "../images/veges-green-dark.svg"
import vegeI from "../images/vege-green-dark.svg"
import bakeryI from "../images/bakery-green-dark.svg"
import fishI from "../images/fish-green-dark.svg"
import ekoI from "../images/eko-green-dark.svg"
import booksI from "../images/books-green-dark.svg"
import alcoI from "../images/alco-green-dark.svg"
import meatI from "../images/meat-green-dark.svg"
import cheeseI from "../images/cheese-green-dark.svg"
import beveI from "../images/beve-green-dark.svg"
import marketersI from "../images/marketers-green-dark.svg"

import be from "../images/flags/BELGIUM.svg"
import cz from "../images/flags/CZECHIA.svg"
import ge from "../images/flags/GE.svg"
import ha from "../images/flags/HAWAII.svg"
import hu from "../images/flags/HUNGARY.svg"
import ind from "../images/flags/INDIA.svg"
import ir from "../images/flags/IRAN.svg"
import ita from "../images/flags/ITALY.svg"
import jap from "../images/flags/JAPAN.svg"
import me from "../images/flags/MIDDLE-EAST.svg"
import mex from "../images/flags/MEXICO.svg"
import sk from "../images/flags/SLOVAKIA.svg"
import spa from "../images/flags/SPAIN.svg"
import swe from "../images/flags/SWEDEN.svg"
import thai from "../images/flags/THAILAND.svg"
import tur from "../images/flags/TURKEY.svg"
import usa from "../images/flags/USA.svg"
import vie from "../images/flags/VIETNAM.svg"

export const storesIcons = {
  STORES_F: marketI,
  STORES_E: cuisineI,
  STORES_G: groceryI,
  STORES_C: barsI,

  STORES_E_WC: globeI,
  STORES_E_VE: vegeI,

  STORES_F_M: marketersI,

  STORES_G_FV: vegesI,
  STORES_G_BC: bakeryI,
  STORES_G_FC: fishI,
  STORES_G_OF: ekoI,
  STORES_G_FB: booksI,
  STORES_G_AS: alcoI,
  STORES_G_MF: meatI,
  STORES_G_CH: cheeseI,

  STORES_C_B: beveI,
}

export const flagsIcons = {
  ["sk-havajska-kuchyna"]: ha,
  ["sk-madarska-kuchyna"]: hu,
  ["sk-ceska-kuchyna"]: cz,
  ["sk-indicka-kuchyna"]: ind,
  ["sk-iranska-kuchyna"]: ir,
  ["sk-talianska-kuchyna"]: ita,
  ["sk-japonska-kuchyna"]: jap,
  ["sk-kuchyna-blizkeho-vychodu"]: me,
  ["sk-slovenska-kuchyna"]: sk,
  ["sk-spanielska-kuchyna"]: spa,
  ["sk-svedska-kuchyna"]: swe,
  ["sk-thaiska-kuchyna"]: thai,
  ["sk-turecka-kuchyna"]: tur,
  ["sk-americka-kuchyna"]: usa,
  ["sk-vietnamska-kuchyna"]: vie,
  ["sk-belgicka-kuchyna"]: be,
  ["sk-mexicka-kuchyna"]: mex,
  ["sk-gruzinska-kuchyna"]: ge,

  ["en-hawaiian-cuisine"]: ha,
  ["en-hungarian-cuisine"]: hu,
  ["en-czech-cuisine"]: cz,
  ["en-indian-cuisine"]: ind,
  ["en-iranian-cuisine"]: ir,
  ["en-italian-cuisine"]: ita,
  ["en-japanese-cuisine"]: jap,
  ["en-middle-eastern-cuisine"]: me,
  ["en-slovak-cuisine"]: sk,
  ["en-spanish-cuisine"]: spa,
  ["en-swedish-cuisine"]: swe,
  ["en-thai-cuisine"]: thai,
  ["en-turkish-cuisine"]: tur,
  ["en-american-cuisine"]: usa,
  ["en-vietnamese-cuisine"]: vie,
  ["en-belgian-cuisine"]: be,
  ["en-mexican-cuisine"]: mex,
  ["en-georgian-cuisine"]: ge,
}
